<app-bread-crumb [items]="[{text:  'sócio',link:'/admin/members'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe do Sócio'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-4">
      <!-- Profile Image -->
      <div class="box box-success" style="border-top: 2px solid #f35309;">

        <div class="box-body box-profile">

          <img 
            class="img-responsive" 
            style="width:150px ;height:150px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;" 
            [src]="member.photo || 'http://localhost:4200/assets/Khuzela.png'"
            alt="imagem do parceiro">

          <h3 class="profile-username text-center">{{member?.name}}</h3>

          <p class="text-muted text-center">{{member?.email}}</p>
          <ul class="list-group list-group-unbordered">
            <!-- <li class="list-group-item text-center" [ngStyle]="{backgroundColor: member.color,color:'white'}"><strong>Cor Predominante</strong></li> -->

            <li class="list-group-item">

              <div class="upload-btn-wrapper">

                <button class="btn btn-outline-danger btn-block">
                  <i class="fa fa-cloud-upload"></i> Clique aqui para actualizar o logotipo
                </button>
    
                <input title="" type="file" #iptFile (input)="updateImageProfile($event,member)"/>
              </div>

            </li>
          </ul>

        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </div>

    <div class="col-md-8">

      <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

        <div class="box-footer no-padding">
          <ul class="nav nav-stacked">
            <li><a routerLink="/admin/members/detail"><strong>Número do Membro</strong> <span class="pull-right">{{member?.member_number}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Tipo de Sócio</strong> <span class="pull-right">{{member?.member_type}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Telefone</strong> <span class="pull-right">{{member?.phone}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Provincia</strong> <span class="pull-right">{{member?.city?.name}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Endereço</strong> <span class="pull-right">{{member?.address}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Quota a Pagar</strong> <span class="pull-right">{{member?.quote?.quota_description}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Tipo de Documento</strong> <span class="pull-right">{{member?.document?.name}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Número de Documento</strong> <span class="pull-right">{{member?.document_number}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Clube</strong> <span class="pull-right">{{member?.club?.name}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Estado</strong> <span class="pull-right">{{member?.status_user || 'Não Configurado'}}</span></a></li>
            <li><a routerLink="/admin/members/detail"><strong>Criado em:</strong> <span class="pull-right">{{member?.created_at | date:'dd/MM/yyyy HH:mm:ss'}}</span></a></li>
            <li class="botao">
              <button type="button" (click)="editMember(member)" class="btn btn-outline-danger pull-right"><strong><i
                    class="fa fa-edit"></i> Editar</strong></button>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>

</section>